import { ButtonHTMLAttributes, FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface SelectableTileProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'type'
> {
  title: string
  description?: string
  icon?: string
  isSelected?: boolean
}

export const SelectableTile: FC<SelectableTileProps> = ({
  title,
  description,
  icon,
  isSelected = false,
  className,
  disabled,
  onClick,
  ...buttonProps
}) => {
  const handleClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'] = (
    event,
  ) => {
    if (disabled) {
      event.preventDefault()

      return
    }

    onClick?.(event)
  }

  return (
    <button
      className={clsx(s.tile, className, {
        [s.selected]: isSelected,
      })}
      type="button"
      aria-disabled={disabled}
      onClick={handleClick}
      {...buttonProps}
    >
      <span className={s.content}>
        {icon && (
          <img
            src={icon}
            alt={title}
            className={s.icon}
          />
        )}
        <span className={clsx(s.title, 'semi-bold-14')}>{title}</span>

        {isSelected && (
          <AppIcon
            id={AllIcons.CHECK_ROUNDED}
            className={s.selectedIcon}
            width={18}
            height={18}
            color="var(--link)"
          />
        )}
      </span>
    </button>
  )
}
